import React from "react";
import { useIntl } from "react-intl";
import NoData from "./NoData";

const NoCourseData = ({ children, data }) => {
  const intl = useIntl();

  return (
    <NoData
      data={data}
      message={intl.formatMessage({
        id: "Shared.NoCourseData.NoCourse",
        defaultMessage: "There are no courses. Please check later for new contents..."
      })}
    >
      {children}
    </NoData>
  );
};

export default NoCourseData;
